import {Component, inject, OnInit} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {LinkTabOpenerDirective} from '../../shared/directives/link-tab-opener.directive';
import {sortItems} from '../../shared/utils/array-utils';
import {DirectusService, FooterLink} from '@frontend/directus';

type FooterLinksByCategory = Record<string, Omit<FooterLink, 'category'>[]>;

@Component({
  selector: 'app-footer',
  imports: [TranslocoPipe, LinkTabOpenerDirective],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  private readonly directusService = inject(DirectusService);

  linksByCategory: FooterLinksByCategory = {};
  contactLinks: Omit<FooterLink, 'category'>[] = [];
  facebookLink = '/';
  linkedInLink = '/';
  logoLink = '/';
  address = '';
  phone = '';
  mail = '';

  ngOnInit() {
    this.loadFooterItems();
  }

  loadFooterItems() {
    this.directusService.loadFooterLinks().subscribe({
      next: (response: FooterLink[]) => {
        const linkMap = response.reduce(
          (linksByCategory: FooterLinksByCategory, {category, ...rest}: FooterLink) => {
            if (!linksByCategory[category]) {
              linksByCategory[category] = [];
            }
            linksByCategory[category].push(rest);
            return linksByCategory;
          },
          {} as FooterLinksByCategory,
        );

        for (const category in linkMap) {
          if (Object.prototype.hasOwnProperty.call(linkMap, category)) {
            linkMap[category] = sortItems(linkMap[category]);
          }
        }
        this.linksByCategory = linkMap;

        this.contactLinks = this.linksByCategory['Contact'] ?? [];
        this.facebookLink = this.contactLinks.find((item) => item.name === 'Facebook')?.url ?? '';
        this.linkedInLink = this.contactLinks.find((item) => item.name === 'Linked In')?.url ?? '';
        this.logoLink = this.contactLinks.find((item) => item.name === 'Logo')?.url ?? '';
        this.address = this.contactLinks.find((item) => item.name === 'Address')?.url ?? '';
        this.phone = this.contactLinks.find((item) => item.name === 'Phone')?.url ?? '';
        this.mail = this.contactLinks.find((item) => item.name === 'Mail')?.url ?? '';
      },
    });
  }
}
